import { API_URL, apiRequest, WS_API_URL } from './api';
import { Conversations } from '../components/model';

const API_CONVERSATION_URL = `${API_URL}/conversation`;

export const WS_API_CONVERSATION_URL = `${WS_API_URL}/conversation`;

// Conversations API Methods
export const fetchAllConversations = async () => {
  return apiRequest('GET', API_CONVERSATION_URL);
};

export const fetchConversationByUuid = async (
  uuid: string
): Promise<Conversations> => {
  return apiRequest(
    'GET',
    `${API_CONVERSATION_URL}/${uuid}`
  ) as Promise<Conversations>;
};

export const saveOrUpdateConversation = async (
  conversation: Conversations
): Promise<Conversations> => {
  return apiRequest(
    'POST',
    API_CONVERSATION_URL,
    conversation
  ) as Promise<Conversations>;
};

export const deleteConversation = async (id: number) => {
  return apiRequest('DELETE', `${API_CONVERSATION_URL}/${id}`);
};
